import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_SYSTEM',
    statusCode: 500,
    message: {
        en: 'System Error',
    },
} as CustomErrorType;